import { Icon, Text } from 'components'

import styles from './styles.module.scss'

type InstructionProps = {
  content: string
}

const Instruction = ({ content }: InstructionProps) => {
  return (
    <div className={styles.container}>
      <div>
        <Icon width={16} name="information" color="element-default" />
      </div>
      <Text size="sm">{content}</Text>
    </div>
  )
}

export default Instruction
